var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TestingOrganizationForm',{attrs:{"testing-organization":_vm.organization,"put-loading":_vm.putLoading},on:{"on-abort":_vm.onTestingOrganizationAbortUpdate,"on-submit":_vm.onTestingOrganizationUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }